// molecules/Nav.js
import React from 'react';
import styled from '@emotion/styled';
import { useNavigation } from 'context/NavigationContext';
import { useContent } from 'context/ContentContext';
import { useScrollContext } from 'context/ScrollContext';
import MenuButtonMobile from 'components/layout/MenuButtonMobile';

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 3rem;
`;

const NavList = styled.ul`
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
    gap: 1rem;
  }
`;

const NavItem = styled.li`
  margin: 0 1rem;

  &:last-of-type {
    margin-right: 0;
  }
`;

const NavLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.red};
  padding: 0.8rem 0.1rem;
  position: relative;

  span {
    font-weight: ${({ isActive }) => (isActive ? '700' : '400')};
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      opacity: 0.8;
    }
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.red};
    transform: ${({ isActive }) => (isActive ? 'scaleX(1)' : 'scaleX(0)')};
    transform-origin: left;
    transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transition-property: transform, opacity;
    opacity: ${({ isActive }) => (isActive ? '1' : '0')};
  }
`;

const Nav = () => {
  const { activeSection, handleSectionChange } = useNavigation();
  const { messages = {} } = useContent();
  const { isScrolled } = useScrollContext();

  // Build nav items with translated labels
  const navItems = [
    { id: 'home', label: messages?.navigation?.home || 'Home' },
    { id: 'menu', label: messages?.navigation?.menu || 'Menu' },
    { id: 'about', label: messages?.navigation?.about || 'About' },
    { id: 'location', label: messages?.navigation?.location || 'Location' },
  ];

  return (
    <NavContainer>
      <NavList>
        {navItems.map(({ id, label }) => (
          <NavItem key={id}>
            <NavLink
              isActive={activeSection === id}
              isScrolled={isScrolled}
              onClick={() => handleSectionChange(id)}
            >
              {label}
            </NavLink>
          </NavItem>
        ))}
      </NavList>
      <MenuButtonMobile />
    </NavContainer>
  );
};

export default Nav;
